import {Base64} from 'js-base64'
import {GCodeParameters} from "../stores/GCodeParametersStore";

export class GCodeSettingBuilder {
    private plateThickness?: number
    private millingDepth?: number // cooper width
    private millingSpeed?: number
    private moveHeight?: number
    private toolChangeHeight?: number
    private offsetOnDrillCutDepth?: number
    private holeDiameterOffset?: number
    private skipFirstN?: number
    private drillType: DrillType = DrillType.DRILL
    private useSeparateFiles?: boolean = true
    private cutStep?: number
    private bridgeHeightPercentage?: number

    private GCodeSettingBuilder() {
    }

    static instance(): GCodeSettingBuilder {
        return new GCodeSettingBuilder()
    }

    withParameters(parameters: GCodeParameters): GCodeSettingBuilder {
        this.plateThickness = parameters.plateThickness
        this.millingDepth = parameters.millingDepth
        this.millingSpeed = parameters.millingSpeed
        this.moveHeight = parameters.moveHeight
        this.toolChangeHeight = parameters.toolChangeHeight
        this.offsetOnDrillCutDepth = parameters.offsetOnDrillCutDepth
        this.holeDiameterOffset = parameters.holeDiameterOffset
        this.skipFirstN = parameters.skipFirstN
        this.drillType = parameters.drillType
        this.useSeparateFiles = parameters.useSeparateFiles
        this.cutStep = parameters.cutStep
        this.bridgeHeightPercentage = parameters.bridgeHeightPercentage
        return this
    }

    withPlateThickness(plateThickness: number): GCodeSettingBuilder {
        this.plateThickness = plateThickness
        return this
    }

    withMillingDepth(millingDepth: number): GCodeSettingBuilder {
        this.millingDepth = millingDepth
        return this
    }

    withMillingSpeed(millingSpeed: number): GCodeSettingBuilder {
        this.millingSpeed = millingSpeed
        return this
    }

    withMoveHeight(moveHeight: number): GCodeSettingBuilder {
        this.moveHeight = moveHeight
        return this
    }

    withToolChangeHeight(toolChangeHeight: number): GCodeSettingBuilder {
        this.toolChangeHeight = toolChangeHeight
        return this
    }

    withOffsetOnDrillCutDepth(offsetOnDrillCutDepth: number): GCodeSettingBuilder {
        this.offsetOnDrillCutDepth = offsetOnDrillCutDepth
        return this
    }

    withHoleDiameterOffset(holeDiameterOffset: number): GCodeSettingBuilder {
        this.holeDiameterOffset = holeDiameterOffset
        return this
    }

    withSkipFirstN(skipFirstN: number): GCodeSettingBuilder {
        this.skipFirstN = skipFirstN
        return this
    }

    withDrillType(drillType: DrillType): GCodeSettingBuilder {
        this.drillType = drillType
        return this
    }

    withUseSeparateFiles(useSeparateFiles: boolean): GCodeSettingBuilder {
        this.useSeparateFiles = useSeparateFiles
        return this
    }

    build(serializer: GCodeParametersSerializer): any {
        serializer.addParameter("plateThickness", this.plateThickness)
        serializer.addParameter("millingDepth", this.millingDepth)
        serializer.addParameter("millingSpeed", this.millingSpeed)
        serializer.addParameter("moveHeight", this.moveHeight)
        serializer.addParameter("toolChangeHeight", this.toolChangeHeight)
        serializer.addParameter("offsetOnDrillCutDepth", this.offsetOnDrillCutDepth)
        serializer.addParameter("holeDiameterOffset", this.holeDiameterOffset)
        serializer.addParameter("skipFirstN", this.skipFirstN)
        serializer.addParameter("drillType", this.drillType)
        serializer.addParameter("useSeparateFiles", this.useSeparateFiles)
        serializer.addParameter("cutStep", this.cutStep)
        serializer.addParameter("bridgeHeightPercentage", this.bridgeHeightPercentage)

        return serializer.serialize()
    }
}

export interface GCodeParametersSerializer {
    addParameter(name: string, value: any): void

    serialize(): any
}

export class GCodeParametersToStringSerializer implements GCodeParametersSerializer {
    private params: any = {}

    addParameter(name: string, value: any): void {
        this.params[name] = value
    }

    serialize() {
        let jsonParams = JSON.stringify(this.params);
        return Base64.encode(jsonParams)
    }
}

export enum DrillType {
    DRILL,
    MILLING
}